import InvestmentPaymentModal from './investmenr-payment-modal';

interface SummaryDetailsFormProps {
    projectName: string;
    projectLocation: string;
    investMentAmount: string;
    sourceOfFunding: string;
    baseFee: string;
    inspectionFee: string;
    zone?: string;
    personalContribution: string;
    loanAmount: string;
    institutionProvidingLoanName: string;
    bankName: string;
    bankAddress: string;
    totalFees: string;
    showPaymentForm: boolean;
    setShowPaymentForm: React.Dispatch<React.SetStateAction<boolean>>;
    handleModalSubmit: () => void
    
}

export default function SummaryInvestmentDetailsForm({
    investMentAmount,
    bankAddress,
    bankName,
    institutionProvidingLoanName,
    loanAmount,
    personalContribution,
    baseFee,
    inspectionFee,
    zone,
    totalFees,
    showPaymentForm,
    setShowPaymentForm,
    handleModalSubmit
}: SummaryDetailsFormProps) {
    const fmt = (value: string) => parseInt(value).toLocaleString();

    return (
        <div className="w-full">
            <h1 className="text-lg font-bold mb-2">Submission</h1>
            <p className="text-xs mb-4 text-[#041528]">Complete payment to submit submit your application</p>
            <hr className="mb-4" />

            <div className="mb-4">
                <div className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <span className="text-xs text-gray-500">Estimated Investment Amount</span>
                        <p className="text-sm font-semibold capitalize">{investMentAmount}</p>
                    </div>

                    <div>
                        <span className="text-xs text-gray-500">Personal Contribution</span>
                        <p className="text-sm font-semibold capitalize">{personalContribution}</p>
                    </div>
                    <div>
                        <span className="text-xs text-gray-500">Loan Amount</span>
                        <p className="text-sm font-semibold capitalize">{loanAmount}</p>
                    </div>

                    <div>
                        <span className="text-xs text-gray-500">Institution Providing the Loan</span>
                        <p className="text-sm font-semibold capitalize">{institutionProvidingLoanName}</p>
                    </div>

                    <div>
                        <span className="text-xs text-gray-500">Bank Name</span>
                        <p className="text-sm font-semibold capitalize">{bankName}</p>
                    </div>

                    <div>
                        <span className="text-xs text-gray-500">Bank Address</span>
                        <p className="text-sm font-semibold capitalize">{bankAddress}</p>
                    </div>
                </div>
            </div>

            <hr className="mb-4" />

            <div className="mb-4 mt-2">
                <h2 className="text-sm font-semibold mb-2">Fee Calculation</h2>

                <div className="space-y-2 text-gray-700 text-sm">
                    <div className="flex justify-between">
                        <span>Approval Letter (paid at application)</span>
                        <span>{fmt(baseFee)} TZS</span>
                    </div>
                    <div className="flex justify-between">
                        <span>Inspection Fee{zone ? ` (${zone})` : ""}</span>
                        <span>{fmt(inspectionFee)} TZS</span>
                    </div>
                    <div className="border-t border-gray-300 pt-2 flex justify-between font-semibold text-gray-900">
                        <span>Total Fees</span>
                        <span>{fmt(totalFees)} TZS</span>
                    </div>
                </div>
            </div>

            <hr className="mb-4" />

            <div className="">
                <div>
                    <input
                        required
                        type="checkbox"
                        className="mr-2"
                    />
                    <span className="text-sm text-gray-500">I agree to the terms and conditions</span>
                </div>
                <div>
                    <p className="font-light text-sm text-left mt-1">
                        I hereby declare that all the information provided in this application is accurate, complete, and truthful to the best of my knowledge. I understand that any false or misleading information may result in the rejection of my application or the revocation of approval at any stage.
                    </p>
                    <p className="mt-3 font-light text-sm text-left">
                        I accept full responsibility for the validity of the information submitted and agree to comply with all applicable regulations and requirements set forth by the Zanzibar Commission for Tourism (ZCT).
                    </p>
                </div>
            </div>

            
            <>
                <InvestmentPaymentModal
                    inspectionFee={inspectionFee}
                    isOpen={showPaymentForm}
                    onClose={() => setShowPaymentForm(false)}
                    onSubmit={handleModalSubmit}
                />

            </>
        </div>
    );
}